import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Компания |||| Компании',
      fields: {
        uniqName: 'Уникальный ключ',
        name: 'Название',
      }
    }
  }
}